import i18n from '@service/I18nService';

export const getCurrentLanguageWord = <T extends object>(langObj: T) =>
  (langObj as Record<string, string>)?.[i18n.language || 'uz'];
